import EventsBoard from './events-board';

export default EventsBoard;
